/// helper functions for PDF generation
import Vue from 'vue'
import Vuex from 'vuex'
import constants from '@/data/constants'
import CommonMixin from './CommonMixin.js'
Vue.mixin(CommonMixin)

export const ListsMixin = {
    methods: {

        getImagefromAPI(id) {
            var request = new XMLHttpRequest()
            var requestER = new XMLHttpRequest()
            var src = ''
            // if (top_photo && id > 0) {
            src = 'https://api.tb-cms.org/vueimages/' + id + '_big.txt'
            request.open(
                'GET',
                src,
                false
            )
            request.send(null)
            // request.onreadystatechange = function() {
            if (request.readyState === 4) {
                // var response = JSON.parse(request.responseText);
                if (request.status === 200 && request.statusText === 'OK') {
                    var type = request.getResponseHeader('Content-Type')
                    if (type.indexOf('text') !== 1) {
                        return request.responseText
                    }
                } else {
                    requestER.open('GET', 'https://api.tb-cms.org/vueimages/ir.txt', false)
                    requestER.send(null)
                    if (requestER.readyState === 4) {
                        if (requestER.status === 200 && requestER.statusText === 'OK') {
                            var type = requestER.getResponseHeader('Content-Type')
                            if (type.indexOf('text') !== 1) {
                                return requestER.responseText
                            }
                        } else {
                            return ''
                        }
                    }
                }
            }
            // }
            // request.onreadystatechange = function () {
            //  if (request.readyState === 4 && request.status === 200) {
            // var type = request.getResponseHeader('Content-Type');
            // if (type.indexOf("text") !== 1) {
            // return request.responseText;
            // }
            // }
            // }
        },

        getLogo() {
            var request = new XMLHttpRequest()
            request.open('GET', 'https://api.tb-cms.org/vueimages/logo.txt', false)
            request.send(null)
            if (request.readyState === 4) {
                if (request.status === 200 && request.statusText === 'OK') {
                    var type = request.getResponseHeader('Content-Type')
                    if (type.indexOf('text') !== 1) {
                        return request.responseText
                    }
                } else {
                    return ''
                }
            }
            return request.responseText
        },

        formatExhibitionData(exhibitions) {
            // console.log('HELPER');
            // console.log(exhibitions.length);
            return exhibitions.map(a => {
                return (
                    'Exhibition period: ' + a.duration_start + ' – ' + a.duration_end + '\n' +
                    'Exhibition title: ' + a.title + '\n' +
                    'Institution: ' + a.institution + '\n' +
                    'City: ' + a.city + '\n' +
                    (a.show_type == '0' || a.show_type == 0 || a.show_type == null ? 'Solo\n' : 'Group\n') +
                    (a.note != null ? 'Note: ' + a.note + '\n' : '')
                )
            })
        },

        formatListData(artworks, output_fields) {
            console.log("formatListData", output_fields)
            return artworks.map(textRow => {

                var todos = []
                var packings = []
                var exhibitions = []
                var artist_gender = ''
                var artist_nationality = ''
                var artist_birth_year = ''
                var artist_decade = ''

                var output_fields_ids = output_fields.map((of) => of.id)

                if (output_fields_ids.includes('todos')) {
                    todos = Object.assign(
                        [],
                        this.$store.state.todos.filter(t => {
                            return textRow.id == t.artwork_id
                        })
                    )
                    todos = todos.map(a => {
                        return a.title
                    })
                }

                if (output_fields_ids.includes('packings')) {
                    // console.log('PACKINGS')
                    packings = Object.assign(
                        [],
                        this.$store.state.packings.filter(t => t.artwork_id == textRow.id)
                    )
                    // console.log(this.$store.state.packings.length)
                    // console.log('packingss')
                    // console.log(packings)
                    packings = packings.map(a => {
                        // console.log(a)
                        // var width = a.width ? (a.width) : ''
                        // // console.log(width)
                        // var lenght = a.lenght ? (a.lenght) : ''
                        // // console.log(lenght)
                        // var height = a.height ? (a.height) : ''
                        // // console.log(height)
                        // var cm = width || lenght || height ? ' cm' : ''
                        // // console.log(cm)

                        // var xAfterwidth = a.width & a.lenght ? ' x ' : ''
                        // // console.log(xAfterwidth)
                        // var xAfterlenght = a.height & a.lenght ? ' x ' : ''
                        // // console.log(xAfterlenght)

                        var comma = a.width || a.lenght || a.height ? ', ' : ''

                        let dims = [];

                        if (a.height) {
                            dims.push(`${a.height} (h)`);
                        }

                        if (a.lenght) {
                            dims.push(a.lenght);
                        }

                        if (a.width) {
                            dims.push(a.width);
                        }

                        var dimsall = dims.join(" x ") + " cm";

                        var weight = a.weight ? (', ' + a.weight) + ' kg' : ''
                        // console.log(weight)
                        // var kg = weight ? ' kg' : ''
                        // console.log(`${a.colli} - ${a.packing}${a.width}${xAfterwidth}${a.lenght}${xAfterlenght}${a.height}${cm}${a.weight}`)
                        // console.log(`${a.colli} - ${a.packing}${comma}${width}${xAfterwidth}${lenght}${xAfterlenght}${height}${cm}${weight}`)

                        return `${a.colli} - ${a.packing}${comma}${dimsall}${weight}`
                    })
                }

                if (output_fields_ids.includes('exhibitions')) {
                    exhibitions = Object.assign(
                        [],
                        this.$store.state.exhibitions.filter(t => {
                            return t.artworks.map(a => (a = a.id)).includes(textRow.id)
                        })
                    )
                    if (exhibitions && exhibitions.length > 0) {
                        exhibitions = this.formatExhibitionData(exhibitions);
                    }
                }
                if (output_fields_ids.includes('artist_gender')) {
                    artist_gender = textRow.artist_id ? this.get_artist_gender(textRow.artist_id) : 'no gender'
                }
                if (output_fields_ids.includes('artist_nationality')) {
                    artist_nationality = textRow.artist_id ? this.get_artist_nationality(textRow.artist_id) : 'no nationality'
                }
                if (output_fields_ids.includes('artist_birth_year')) {
                    artist_birth_year = textRow.artist_id ? this.get_artist_birth_year(textRow.artist_id) : ''
                }
                if (output_fields_ids.includes('artist_decade')) {
                    artist_decade = textRow.artist_id ? this.get_artist_decade(textRow.artist_id) : ''
                }

                return this.formatListRowData(textRow, todos, exhibitions, packings, artist_gender, artist_nationality, artist_birth_year, artist_decade)
            })
        },
        getLastLog(id) {
            var logs = this.$store.state.artwork_location_logs
            // if (copy == 'packings') {
            //   if (logs && logs.length > 0) {
            //     var out = logs
            //       .filter((ll) => ll.artwork_packing_id === id)
            //       .sort(function (a, b) {
            //         if (a.change_date > b.change_date) {
            //           return -1
            //         }
            //         if (a.change_date < b.change_date) {
            //           return 1
            //         }
            //         return 0
            //       })[0]
            //     if (out) {
            //       return out
            //     } else {
            //       return ''
            //     }
            //   } else {
            //     return ''
            //   }
            // } else {
            if (logs && logs.length > 0) {
                var out = logs
                    .filter((ll) => ll.copy === 'artwork' && ll.artwork_id === id)
                    .sort(function (a, b) {
                        if (a.change_date > b.change_date) {
                            return -1
                        }
                        if (a.change_date < b.change_date) {
                            return 1
                        }
                        return 0
                    })[0]
                //   console.log(out['artwork_location_id'])
                if (out && out['artwork_location_id'] > 0) {
                    var l = this.$store.state.locations.find(
                        (al) => al.id === out['artwork_location_id']
                    )
                    if (l) {
                        return l.name
                    } else {
                        return ''
                    }

                } else {
                    return ''
                }
            } else {
                return ''
            }
            // }
        },
        formatListRowData(textRow, todos, exhibitions, packings, artist_gender, artist_nationality, artist_birth_year, artist_decade) {
            var latest_insurance = this.getLatestInsuranceValueText(textRow.id)
            var location_name = this.get_location_name(textRow.artwork_location_id) || ''

            return {
                type_of_work_id: textRow.type_of_work_id ? this.constants.TYPES_OF_WORK.find(tow => tow.id === textRow.type_of_work_id).name : '',
                technician: textRow.technician ? `Technician: ${textRow.technician}` : '',
                space_max_min: textRow.space_max_min ? `Space (max/min): ${textRow.space_max_min}` : '',
                required_equipment: textRow.required_equipment ? `Technical Equipment: ${textRow.required_equipment}` : '',
                installation_requirements: textRow.installation_requirements ? `Existing Equipment: ${textRow.installation_requirements}` : '',
                tools_and_gear: textRow.tools_and_gear ? `Tools & Gear: ${textRow.tools_and_gear}` : '',
                light: textRow.light ? `Light: ${textRow.light}` : '',
                climate_and_conditions: textRow.climate_and_conditions ? `Climate & Conditions: ${textRow.climate_and_conditions}` : '',
                power: textRow.power ? `Power: ${textRow.power}` : '',
                spare_or_replacement_parts: textRow.spare_or_replacement_parts ? `Spare or replacement parts: ${textRow.spare_or_replacement_parts}` : '',
                display_notes_and_other_special_merged: textRow.display_notes_and_other_special_merged ? `Other / Special: ${textRow.display_notes_and_other_special_merged}` : '',
                projection: textRow.projection ? `Projection (Size, height, distance, screens): ${textRow.projection}` : '',
                sound_and_acoustic: textRow.sound_and_acoustic ? `Sound and acoustic specifications: ${textRow.sound_and_acoustic}` : '',
                on_off_procedure: textRow.on_off_procedure ? `On-and Off-Procedure: ${textRow.on_off_procedure}` : '',
                maintenance: textRow.maintenance ? `Maintenance: ${textRow.maintenance}` : '',
                security_and_safety_details: textRow.security_and_safety_details ? `Security and Safety Details: ${textRow.security_and_safety_details}` : '',
                regular_inspection: textRow.regular_inspection ? `Regular inspection/ Pay attention to: ${textRow.regular_inspection}` : '',
                cleaning_artwork: textRow.cleaning_artwork ? `Cleaning Artwork (how/ what products/ how often): ${textRow.cleaning_artwork}` : '',
                contacts_producers: textRow.contacts_producers ? `Contacts / Producers: ${textRow.contacts_producers}` : '',
                hanging_devices: textRow.hanging_devices ? `Hanging Devices: ${textRow.hanging_devices}` : '',
                specifications_on_space: textRow.specifications_on_space ? `Specification on hanging/display/ presentation in space: ${textRow.specifications_on_space}` : '',
                // conservator: textRow.conservator ? `XXX: ${textRow.conservator}` : '',
                // conservator: `Consevator: ${textRow.conservator}`,
                last_media_check: textRow.last_media_check ? `Last Condition Check: ${textRow.last_media_check}` : '',
                // last_media_check: `Last Media Check: ${textRow.last_media_check}`,
                paid_in_country: textRow.paid_in_country ? `Paid in country: ${textRow.paid_in_country}` : '',
                import_export_notes: textRow.import_export_notes ? `Import Notes: ${textRow.import_export_notes}` : '',
                import_export_history: textRow.import_export_history ? `Import Export History: ${textRow.import_export_history}` : '',
                import_date: textRow.import_date ? `Import Date: ${textRow.import_date}` : '',
                top_photo_id: textRow.top_photo_id,
                top_photo: textRow.top_photo,
                import_taxes: textRow.import_taxes ? `Import Taxes: ${textRow.import_taxes}` : '',
                title: textRow.production_date_new ? textRow.title + ', ' + textRow.production_date_new : textRow.title,
                subtitle: textRow.subtitle,
                full_name: textRow.name,
                classification: textRow.classification
                    ? textRow.classification.toUpperCase()
                    : '',
                accession_number: textRow.accession_number
                    ? textRow.accession_number
                    : '',
                production_date_new: textRow.production_date_new,
                acquisition_date:
                    'Acquisition Date: ' + this.format_date(textRow.acquisition_date),
                deaccession_date:
                    'Deaccession Date: ' + this.format_date(textRow.deaccession_date),
                acquisition_source_text: 'Acquisition Source: ' + this.get_contact(textRow.acquisition_source_id),
                acquisition_method_text: textRow.acquisition_method_text,
                visa_status_text: textRow.visa_status ? ('Visa Status: ' + this.get_visa_status(textRow.visa_status)) : '',
                ownership_info: this.getOwnershipName(textRow.ownership),
                ownership: textRow.ownership,
                edition_state: textRow.edition_state,
                certificate_new:
                    'Certificate: ' + (textRow.certificate_new == 1 ? 'Yes' : 'No'),
                media_material_description: textRow.media_material_description,
                dim: textRow.dim_f_json,
                location_name: location_name,
                location_notes: textRow.location_notes,
                deaccessioned:
                    'Deaccessioned: ' + (textRow.deaccessioned == 1 ? 'Yes' : 'No'),
                credit: textRow.credit,
                insurance_value_text: textRow.insurance_value_text,
                insurance_value_latest: latest_insurance ? 'Insurance Value: ' + latest_insurance : textRow.insurance_value_text,
                purchase_price_text: textRow.purchase_price_text,
                signature_new:
                    'Signature: ' + (textRow.signature_new == 1 ? 'Yes' : 'No'),
                artist_gender: artist_gender,
                artist_nationality: artist_nationality,
                artist_birth_year: artist_birth_year,
                artist_decade: artist_decade,
                todos: todos.length > 0 ? 'ToDos: ' + todos.join(', ') : '',
                exhibitions:
                    exhibitions.length > 0
                        ? 'Exhibitions: \n ' + exhibitions.join('\n ')
                        : '',
                packings:
                    packings.length > 0
                        ? 'Packings: \n ' + packings.join('\n ')
                        : ''
            }
        }
    }
}

export default ListsMixin

// location_name: this.get_location_name(textRow.artwork_location_id) ? 'Location: ' + this.get_location_name(textRow.artwork_location_id) : '',



// WEBPACK FOOTER //
// ./src/mixins/ListsMixin.js